import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, Server, Network, Layers, Activity, BarChart3,
  AlertTriangle, DollarSign, Bot, Settings, ChevronLeft, ChevronRight,
  Zap, TrendingUp, Upload, FileCode2
} from "lucide-react";
import { SIDEBAR } from "@/constants/testIds";
import { cn } from "@/lib/utils";

const navItems = [
  { to: "/dashboard", icon: LayoutDashboard, label: "Dashboard", testId: SIDEBAR.dashboardLink },
  { to: "/clusters", icon: Server, label: "Clusters", testId: SIDEBAR.clustersLink },
  { to: "/topology", icon: Network, label: "Topology", testId: SIDEBAR.topologyLink },
  { to: "/explorer", icon: Layers, label: "Resources", testId: SIDEBAR.explorerLink },
  { to: "/monitoring", icon: Activity, label: "Monitoring", testId: SIDEBAR.monitoringLink },
  { to: "/analytics", icon: BarChart3, label: "Analytics", testId: SIDEBAR.analyticsLink },
  { to: "/predictive", icon: TrendingUp, label: "Predictive", testId: "sidebar-predictive-link" },
  { to: "/connect", icon: Upload, label: "Connect Cluster", testId: "sidebar-connect-link" },
  { to: "/manifest-analyzer", icon: FileCode2, label: "Manifest Analyzer", testId: "sidebar-manifest-link" },
  { to: "/incidents", icon: AlertTriangle, label: "Incidents", testId: SIDEBAR.incidentsLink },
  { to: "/cost", icon: DollarSign, label: "Cost", testId: SIDEBAR.costLink },
  { to: "/assistant", icon: Bot, label: "AI Assistant", testId: SIDEBAR.assistantLink },
  { to: "/settings", icon: Settings, label: "Settings", testId: SIDEBAR.settingsLink },
];

export default function Sidebar({ collapsed, onToggle }) {
  return (
    <aside
      data-testid={SIDEBAR.nav}
      className={cn(
        "flex flex-col h-full border-r border-slate-800 bg-slate-900/50 transition-all duration-200",
        collapsed ? "w-14" : "w-56"
      )}
    >
      {/* Logo */}
      <div className={cn("flex items-center gap-2 px-3 py-4 border-b border-slate-800", collapsed && "justify-center")}>
        <div className="w-7 h-7 rounded-md bg-indigo-500 flex items-center justify-center flex-shrink-0">
          <Zap size={14} className="text-white" />
        </div>
        {!collapsed && (
          <span className="font-semibold text-sm text-slate-50 tracking-tight" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
            KubeAnalytics
          </span>
        )}
      </div>

      {/* Nav */}
      <nav className="flex-1 py-3 px-2 space-y-0.5 overflow-y-auto">
        {navItems.map(({ to, icon: Icon, label, testId }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testId}
            className={({ isActive }) =>
              cn(
                "flex items-center gap-2.5 px-2 py-2 rounded-md text-sm transition-colors duration-150",
                collapsed && "justify-center",
                isActive
                  ? "bg-indigo-500/15 text-indigo-400 border border-indigo-500/20"
                  : "text-slate-400 hover:text-slate-50 hover:bg-slate-800/60"
              )
            }
          >
            <Icon size={16} strokeWidth={1.75} className="flex-shrink-0" />
            {!collapsed && <span className="truncate">{label}</span>}
          </NavLink>
        ))}
      </nav>

      {/* Collapse toggle */}
      <button
        onClick={onToggle}
        className={cn(
          "flex items-center justify-center px-2 py-3 border-t border-slate-800",
          "text-slate-500 hover:text-slate-300 transition-colors duration-150"
        )}
      >
        {collapsed ? <ChevronRight size={14} /> : <ChevronLeft size={14} />}
      </button>
    </aside>
  );
}
